module.exports = __webpack_public_path__ + "img/navodila_slika_3.e2d9ef0d.png";